export const applicationEditConstants = {
	EDIT_APPLICATION_SUBMIT_REQUEST: "EDIT_APPLICATION_SUBMIT_REQUEST",
	EDIT_APPLICATION_SUBMIT_SUCCESS: "EDIT_APPLICATION_SUBMIT_SUCCESS",
	EDIT_APPLICATION_SUBMIT_FAILURE: "EDIT_APPLICATION_SUBMIT_FAILURE",

	GET_APPLICATION_REQUEST: "APP_EDIT_GET_APPLICATION_REQUEST",
	GET_APPLICATION_SUCCESS: "APP_EDIT_GET_APPLICATION_SUCCESS",
	GET_APPLICATION_ERROR: "APP_EDIT_GET_APPLICATION_ERROR",

	RESET_APPLICATION_EDIT_STATE: "RESET_APPLICATION_EDIT_STATE",
};
